import * as React from "react";

function SvgPostHog(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <path
        d="M0 97.379l39.004 38.951H0V97.379zm0-9.738l48.755 48.689h39.004L0 48.69v38.95zm0-48.69l97.51 97.379h39.003L0 0v38.952zm48.755 0l97.509 97.379V97.379L48.754 0v38.952zM97.51 0v38.952l48.754 48.689V48.689L97.51 0z"
        fill="#F9BD2B"
      />
      <path
        d="M234.023 120.75a37.692 37.692 0 01-26.632-11.016L153.16 55.576v80.754h80.863v-15.58z"
        fill="currentColor"
      />
      <path
        d="M176.563 120.75c4.308 0 7.8-3.488 7.8-7.791 0-4.302-3.492-7.79-7.8-7.79-4.309 0-7.801 3.488-7.801 7.79 0 4.303 3.492 7.791 7.801 7.791z"
        fill="#fff"
      />
      <path
        d="M0 136.33h39.004L0 97.379v38.951zm48.755-87.64L0 0v38.952L48.755 87.64V48.689zM0 48.69v38.95l48.755 48.69V97.379L0 48.689z"
        fill="#1D4AFF"
      />
      <path
        d="M97.51 48.69L48.755 0v38.952L97.51 87.64V48.689zm-48.755 87.64h39.004L48.755 97.379v38.951zm0-87.64v38.95l48.755 48.69V97.379l-48.755-48.69z"
        fill="#F54E00"
      />
    </svg>
  );
}

export default React.forwardRef(SvgPostHog);
